(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') return;

    var thumbsEl = document.querySelector('.product-thumbs-swiper');
    var thumbsSwiper = thumbsEl
      ? new Swiper('.product-thumbs-swiper', {
          slidesPerView: 4,
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
        })
      : null;

    new Swiper('.product-gallery-swiper', {
      slidesPerView: 1,
      loop: !!thumbsEl,
      navigation: {
        nextEl: '.product-gallery-next',
        prevEl: '.product-gallery-prev',
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : {},
    });
  });

  } catch(e) { console.error(e); }
})();
})();
